import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b9fe2852"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "business-list-card"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "business-list-card-title" }, "拎包服务商", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "business-list-card-des" }, [
  /*#__PURE__*/_createTextVNode(" 拎包入住在广义上包括房地产的“精装房”和装修企业的“一站式拎包入住”，他们的共同点不难看出，字面上可以理解为拎着包即可达到入住的水平，从家居上可以理解为实现了硬装+软装+家电+家具一站式家装。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("房地产的“精装房”和装企的“拎包入住”各自有什么优点呢？以下房地产的拎包入住简称精装房，装企的拎包入住简称拎包入住。 ")
], -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("申请开通")
const _hoisted_5 = {
  key: 1,
  class: "business-list-card"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "business-list-card-title" }, "拎包服务商", -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("管理")

import { defineComponent } from 'vue';
import store from '@/store/index';
import { useStore } from '@/store/index';
import { ref, reactive } from 'vue';
import tool from '@/utils/tool';
import router from '@/router/index';
import { ElButton, ElMessage, ElMessageBox } from 'element-plus';
import type { ElForm, Action } from 'element-plus';

interface activityVo {
  id: string;
  type: string;
  status: number;
  auditStatus: number;
  endTimeString: string;
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const ustore = useStore();
const createOrEditFormData: activityVo = {
  id: '',
  type: '7',
  status: 1,
  auditStatus: 0,
  endTimeString: '',
};
const bindData = reactive({
  createOrEditFormData: createOrEditFormData,
});

const activityEvent = () => {
  store.dispatch('businessModule/getActivity', {}).then(
    (data) => {
      if (data.result) {
        bindData.createOrEditFormData = data.result;
      }
    },
    (error) => {
      console.log(error.msg);
    }
  );
};
activityEvent();
const handleToPage = () => {
  router.push('/middleGround/member/businessList/handbagBusiness');
};

return (_ctx: any,_cache: any) => {
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "business-list" }, {
    default: _withCtx(() => [
      (_unref(bindData).createOrEditFormData.status == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _hoisted_3,
            _createVNode(_component_el_container, { class: "business-list-card-btn" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElButton), {
                  class: "business-list-card-btn-w",
                  type: "primary",
                  onClick: handleToPage
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_unref(bindData).createOrEditFormData.status > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_el_form, { "label-width": "80px" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "状态:" }, {
                  default: _withCtx(() => [
                    (_unref(bindData).createOrEditFormData.status == 2)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_7, "审核中"))
                      : _createCommentVNode("", true),
                    (_unref(bindData).createOrEditFormData.status > 2)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_8, "已开通"))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                (_unref(bindData).createOrEditFormData.status > 2)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "有效期至:"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("label", null, _toDisplayString(_unref(bindData).createOrEditFormData.endTimeString), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_container, { class: "business-list-card-btn" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElButton), {
                  class: "business-list-card-btn-w",
                  onClick: handleToPage
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})